exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_object-gops.js
// module id = 193
// module chunks = 0